import React, { useContext, useEffect, useState } from "react";
import {
  calculateReturnStatement,
  concatenateAndTruncate,
  truncateText,
} from "../../utils/application-helper";
import useClickOutside from "../Hooks/UseClickOutside";
import { NavLink, useNavigate } from "react-router-dom";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import blocked from "../img/blocked.png";
import VideoPlayer from "./VideoPlayer";
import undrawProfile from "../img/undraw_profile.svg";
import retweet from "../img/retweet.png";
import ImagePopup from "./ImagePopup";
import LinkPreviewCard from "./LinkPreviewCard";
import bookmark from "../img/bookmark.png";
import bookFilled from "../img/save.png";

const Post = ({
  post,
  deleteHandler,
  editHandler,
  likePostHandler,
  expertiesKey,
  reportPostHandler,
  bookHandler,
  retweetHandler,
}) => {
  const navigate = useNavigate();
  const [isOpen, toggle, containerRef] = useClickOutside(false);
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [showImage, setShowImage] = useState("");
  const [extractedUrls, setExtractedUrls] = useState([]);
  const [modifiedHtmlString, setModifiedHtmlString] = useState("");
  const { user } = authContext;

  const userId = user?.userId || user?.data?.data?.userId;
  const userName = user?.userName || user?.data?.data?.userName;

  var isEdit = userId === post?.userId;

  const playListener = (reelId) => appContext.updateCurrentPlayerId(reelId);
  const stopListener = (reelId) => {
    if (appContext.currentPlayerId === reelId)
      appContext.updateCurrentPlayerId(null);
  };

  useEffect(() => {
    appContext.updateCurrentPlayerId(null);
  }, []);

  const [isTruncated, setIsTruncated] = useState(true);

  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  useEffect(() => {
    const detectHyperlinks = (text) => {
      const regex = /((https?:\/\/)|(www\.))[^\s<]+/g;
      const extracted = [];

      const modifiedText = text.replace(regex, (url) => {
        let newUrl = url.endsWith("</p>")
          ? url.slice(0, -4)
          : url.endsWith(">")
          ? url.slice(0, -1)
          : url;

        let securedUrl;

        if (!newUrl.startsWith("http://") && !newUrl.startsWith("https://")) {
          securedUrl = `https://${newUrl}`;
        } else {
          securedUrl = newUrl;
        }

        extracted.push(securedUrl);

        return `<a href="${securedUrl}" target="_blank">${newUrl}</a>`;
      });

      setExtractedUrls(extracted);
      setModifiedHtmlString(modifiedText);
      return modifiedText;
    };

    if (post?.description) {
      const newModifiedHtml = detectHyperlinks(post?.description);

      const parser = new DOMParser();
      const doc = parser.parseFromString(newModifiedHtml, "text/html");

      const anchorElements = doc.querySelectorAll("a");

      anchorElements.forEach((anchor) => {
        anchor.setAttribute("target", "_blank");
        const href = anchor.getAttribute("href");
        if (href && href.startsWith("www.")) {
          anchor.setAttribute("href", "http://" + href);
        }
      });

      const modifiedHtmlString = new XMLSerializer().serializeToString(doc);
    }
  }, [post?.description]);

  var truncatedText1 = modifiedHtmlString
    ? truncateText(modifiedHtmlString, 400)
    : null;

  return (
    <div className="card  card-one-1 mb-2" key={post?.id}>
      <div className="card-body pb-0">
        {post?.isSharedPost && (
          <div
            className="repost-row"
            onClick={() => navigate(`../${post?.sharedPostUsername}`)}
          >
            <img src={post?.sharedPostPic || undrawProfile} alt="profile" />
            <h6>
              <span>{post?.sharedPostName}</span> reposted this
            </h6>
          </div>
        )}
        <div className="row">
          {/* <NavLink
            to={isEdit ? "../myspace" : `user/${post.userId}`}
            className="row"
          > */}
          <div className="d-flex w-100 justify-content-between align-items-start">
            <div className="col-2 col-sm-2 col-md-1">
              <NavLink
                to={
                  userId === post?.userId
                    ? `../${userName}`
                    : `../${post.user_name}`
                }
              >
                <div className="sme-profile sme-post-profile">
                  <img
                    className={`img-profile rounded-circle ${
                      post?.offerService ? "sme-mini-service" : null
                    }`}
                    src={post.pic_url || undrawProfile}
                  />
                  {post?.offerService && (
                    <div className="sme-mini-icon">SME</div>
                  )}
                </div>
              </NavLink>
            </div>
            <div className="col-9 col-sm-9 col-md-10 pl-4 marl">
              <NavLink
                to={
                  userId === post?.userId
                    ? `../${userName}`
                    : `../${post.user_name}`
                }
              >
                {" "}
                <p className="user-name mb-0 user">{post?.userName} </p>
                <p className="user-des mb-0">
                  {post?.experties &&
                    post?.experties.length > 0 &&
                    concatenateAndTruncate(post?.experties, 30, expertiesKey)}
                </p>
                <span className="post-hour">
                  {calculateReturnStatement(
                    new Date(post?.created_at).getTime()
                  )}
                </span>
              </NavLink>
            </div>
            {/* </NavLink> */}
            <div className="col-1 col-sm-1 col-md-1" ref={containerRef}>
              {
                <div className="dropdown book-edit" onClick={toggle}>
                  <span className="cursor-pointer">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="4"
                      height="17"
                      viewBox="0 0 4 17"
                      fill="none"
                    >
                      <circle cx="2" cy="2" r="2" fill="#000" />
                      <circle cx="2" cy="8" r="2" fill="#000" />
                      <circle cx="2" cy="15" r="2" fill="#000" />
                    </svg>
                  </span>
                </div>
              }
              {isOpen && (
                <div className="schedule-options report-options">
                  {!isEdit &&
                    post?.isAdminBlocked === false &&
                    userId !== post?.userId && (
                      <span
                        className="dropdown-item cursor-pointer mt-1"
                        // onClick={() =>
                        //   appContext.updateModalType(
                        //     "reportPost",
                        //     "Report Post",
                        //     post
                        //   )
                        // }
                        onClick={() => reportPostHandler(post)}
                      >
                        Report
                      </span>
                    )}
                  {isEdit && (
                    <span
                      className="dropdown-item cursor-pointer"
                      onClick={() => editHandler(post)}
                    >
                      Edit
                    </span>
                  )}
                  {isEdit && (
                    <span
                      className="dropdown-item cursor-pointer"
                      onClick={() => deleteHandler(post)}
                    >
                      Delete
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        {post?.isAdminBlocked === false && post?.skillCategoryName && (
          <div className="skill-cat-badge">
            <span className="badge badge-info">{post?.skillCategoryName}</span>
          </div>
        )}
        {post?.isAdminBlocked === false && (
          <p className="post-tag mt-3">
            {post?.description && (
              // <p
              //   dangerouslySetInnerHTML={{
              //     __html: isTruncated ? truncatedText1 : modifiedHtmlString,
              //   }}
              // />
              <span
                dangerouslySetInnerHTML={{
                  __html: isTruncated ? truncatedText1 : modifiedHtmlString,
                }}
              />
            )}
            {modifiedHtmlString && modifiedHtmlString.length > 400 && (
              <span
                onClick={toggleTruncate}
                style={{ color: "#2e3192", cursor: "pointer" }}
              >
                {isTruncated ? "Read More" : "Read Less"}
              </span>
            )}
            <div className="link-card-preview">
              {extractedUrls.length > 0 &&
                extractedUrls.map((item) => {
                  return <LinkPreviewCard key={item || index} url={item} />;
                })}
            </div>
          </p>
        )}
        {post?.isAdminBlocked === false ? (
          <>
            {post?.type === "image" && (
              <img
                src={post.url}
                className="img-fluid post-img object-fit-contain cursor-pointer"
                onClick={() => {
                  setShowImage(post.url);
                }}
              />
            )}
            {post?.type === "video" && (
              <video src={post.url} controls className="img-fluid post-img" />
            )}
            {post?.type === "doc" && (
              <iframe
                src={post.url}
                controls
                className="img-fluid iframe-img"
              />
            )}
            {post?.type === "reels" && (
              <div className="col-md-12">
                <div className="app-video">
                  <div className="video">
                    <VideoPlayer
                      classProp="video-player"
                      id={post.id}
                      wrapper={{
                        width: "100%",
                        height: "500px",
                        overflow: "hidden",
                      }}
                      videoSrc={post.url}
                      playListener={() => playListener(post.id)}
                      stopListener={() => stopListener()}
                    />
                    {/* <div className="videoFooter">
                  <div className="vfooter-text">
                    <img
                      className="img-profile rounded-circle mr-2"
                      src={reelsData?.pic_url || undrawProfile}
                    />
                    <p className="reel-name mb-0 ">{post.userName}</p>
                    {false && reelsData.userId !== userData.userId && (
                      <button
                        type="button"
                        className="btn btn-outline-primary reel-btn px-2"
                      >
                        Follow
                      </button>
                    )}
                  </div>
                </div> */}
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <img
            src={blocked}
            alt="blocked-post"
            className="img-fluid post-img"
          />
        )}
        {post?.isAdminBlocked === false && (
          <div className="d-flex mt-3">
            <span
              onClick={() => likePostHandler(post?.id)}
              className="cursor-pointer d-flex"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="21"
                viewBox="0 0 22 21"
                fill=""
              >
                <path
                  d="M20.504 9.96977V17.4846H17.171L17.0027 17.5035C13.9084 18.1923 11.858 18.689 10.8361 18.9966C9.47867 19.4051 8.97267 19.5048 8.05197 19.5636C7.36337 19.6088 6.58127 19.3557 6.22487 19.0092C6.02797 18.8181 5.88057 18.4254 5.82227 17.8164C5.81019 17.6887 5.76237 17.5665 5.68379 17.4625C5.60522 17.3585 5.4988 17.2765 5.37567 17.2253C5.10177 17.1119 4.87407 16.9271 4.68377 16.6583C4.50777 16.4126 4.39337 15.9548 4.37247 15.2922C4.36879 15.1704 4.33262 15.0515 4.26736 14.9468C4.20211 14.8421 4.10994 14.755 3.99957 14.6937C3.35937 14.3399 3.04257 13.9409 2.97657 13.4726C2.90397 12.9549 3.07997 12.3722 3.54087 11.7086C3.64901 11.5529 3.68928 11.3632 3.65313 11.1796C3.61698 10.9961 3.50724 10.8333 3.34727 10.7258C2.90617 10.4297 2.66417 10.0181 2.60367 9.43427C2.50687 8.50397 3.12837 7.81622 4.53527 7.67867C5.78831 7.56037 7.05345 7.66107 8.26867 7.97582C8.40652 8.01021 8.55179 8.0063 8.68739 7.96455C8.82299 7.9228 8.94328 7.84496 9.03411 7.74017C9.12493 7.63538 9.18252 7.50801 9.20008 7.37305C9.21765 7.23808 9.19447 7.10114 9.13327 6.97832C8.58327 5.86742 8.27747 4.95077 8.20597 4.24097C8.11247 3.29912 8.34017 2.61662 8.87257 2.05382C9.27627 1.62752 9.92197 1.38392 10.164 1.43432C10.483 1.49942 10.6909 1.67582 10.9615 2.29322C11.121 2.65862 11.198 2.96942 11.33 3.69497C11.4565 4.38377 11.5258 4.69457 11.6699 5.10197C12.1044 6.33677 13.1703 7.61672 14.6014 8.49977C15.6044 9.11792 16.6914 9.60193 17.8321 9.93827C17.9033 9.95924 17.9775 9.96986 18.0521 9.96977H20.504ZM20.5502 18.9158C20.9055 18.9252 21.2245 18.8496 21.4918 18.6711C21.8328 18.4433 21.9934 18.0842 21.9967 17.6705L21.9934 9.98132C22.0308 9.57182 21.9043 9.19592 21.6051 8.91662C21.3246 8.65412 20.9583 8.53022 20.5711 8.53862H18.1676C17.1953 8.24291 16.2684 7.82558 15.411 7.29752C14.2582 6.58562 13.409 5.56502 13.0845 4.64522C12.9734 4.32812 12.914 4.06562 12.8018 3.44822C12.65 2.61977 12.5554 2.23442 12.3376 1.73882C11.8866 0.707719 11.2948 0.203719 10.4786 0.0346693C9.67557 -0.131231 8.50627 0.310819 7.76707 1.09202C6.94757 1.95722 6.58567 3.03977 6.71987 4.37747C6.77707 4.95287 6.94427 5.59652 7.21927 6.31367C6.28011 6.18302 5.32768 6.16328 4.38347 6.25487C2.17577 6.47012 0.936068 7.84247 1.11647 9.57707C1.19567 10.3247 1.47947 10.9599 1.96237 11.4587C1.55647 12.2052 1.39477 12.9434 1.49597 13.6637C1.61257 14.4932 2.09657 15.1841 2.90177 15.7206C2.96447 16.4483 3.13937 17.0289 3.44957 17.4636C3.69399 17.8148 4.01289 18.1131 4.38567 18.3393C4.50447 19.0575 4.75417 19.6193 5.16227 20.0141C5.83877 20.6714 7.04767 21.063 8.15207 20.9916C9.20037 20.9244 9.82077 20.8026 11.2838 20.3616C12.2485 20.0708 14.2461 19.5878 17.2568 18.9158H20.5513H20.5502ZM18.6791 9.64322C18.6794 9.54928 18.6602 9.45621 18.6228 9.36934C18.5853 9.28247 18.5303 9.20351 18.4608 9.13699C18.3913 9.07046 18.3087 9.01768 18.2178 8.98167C18.1269 8.94565 18.0295 8.92712 17.9311 8.92712C17.8328 8.92739 17.7356 8.94613 17.645 8.98227C17.5543 9.01841 17.472 9.07123 17.4028 9.13773C17.3335 9.20422 17.2787 9.28309 17.2414 9.36982C17.204 9.45655 17.185 9.54945 17.1853 9.64322V17.7051C17.1851 17.7989 17.2043 17.8918 17.2418 17.9784C17.2792 18.0651 17.3342 18.1439 17.4036 18.2103C17.4729 18.2767 17.5553 18.3294 17.646 18.3654C17.7367 18.4014 17.8339 18.42 17.9322 18.4202C18.0304 18.42 18.1276 18.4014 18.2183 18.3654C18.309 18.3294 18.3914 18.2767 18.4608 18.2103C18.5301 18.1439 18.5851 18.0651 18.6226 17.9784C18.66 17.8918 18.6792 17.7989 18.6791 17.7051V9.64322Z"
                  fill={
                    post?.likeStatus === "Like" ? "rgb(48, 50, 146)" : "black"
                  }
                />
              </svg>
              <p
                className="ml-2 mt-1"
                style={{
                  color:
                    post?.likeStatus === "Like" ? "rgb(48, 50, 146)" : "black",
                }}
              >
                {post?.postLikeCount}
              </p>
            </span>
            <span className="book-mark" onClick={() => bookHandler(post?.id)}>
              <img
                src={post?.isBookmark === "Yes" ? bookFilled : bookmark}
                alt="bookmark"
              />
            </span>
            <span
              className="book-mark"
              onClick={() => retweetHandler(post?.id)}
            >
              <img src={retweet} alt="retweet" />
            </span>
          </div>
        )}
      </div>
      {showImage !== "" && (
        <ImagePopup url={showImage} setShowImage={setShowImage} />
      )}
    </div>
  );
};

export default Post;
